import VideoPlayer from '../elements/VideoPlayer';
(function () {
    var videoheaders = Array.from(document.querySelectorAll('.videoheader'));
    // no videoheader or no vidoe, bail
    if (videoheaders.length === 0)
        return;
    videoheaders.forEach(function (videoheader) {
        // no video
        if (!videoheader.querySelector('video'))
            return;
        // video player
        var videoHolder = videoheader.querySelector('.videoheader-video');
        var videoplayer = new VideoPlayer(videoHolder);
        videoplayer.init();
        // timeline / progressbar
        timeline(videoheader);
    });
    /**
         * Timeline for the video
         */
    function timeline(videoheader) {
        var video = videoheader.querySelector('video');
        var progressBar = videoheader.querySelector('.videoheader-progressbar');
        // we have no video element OR proressbar
        if (!(video instanceof HTMLVideoElement) || !(progressBar instanceof HTMLElement))
            return;
        // update the progressbar on each frame to get a smooth transition
        var update = function () {
            if (!video.paused && !video.ended) {
                // if NaN use 0
                var percent = (video.currentTime / video.duration) * 100 || 0;
                progressBar.style.setProperty('--progress', percent + '%');
            }
            requestAnimationFrame(update);
        };
        // update on play
        video.addEventListener('playing', function () {
            videoheader.classList.add('playing');
            // set duration as prop for text fade out
            videoheader.style.setProperty('--video-duration', video.duration + 's');
            requestAnimationFrame(update);
        });
    }
})();
